module.exports = __webpack_public_path__ + "img/RS.653bc5e8.png";